import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

import { salesforceV2Metadata } from './salesforce-v2-metadata';
import { EnvironmentInjector } from '@angular/core';
import { CommonResourceKind, DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { ConnectionAuthKind, getConnectorV2Name } from 'shell-models-lib';

export const salesforceServiceCloudV2Metadata = async (injector: EnvironmentInjector) => {
    const result: ILinkedServiceTypeMetadata = {
        ...(await salesforceV2Metadata(injector)),
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'SalesforceServiceCloud' as CommonResourceKind
        },
        supportedAuthKindsInTrident: [
            ConnectionAuthKind.Basic
        ],
        type: adfModelTypeMap.salesforceServiceCloudV2.linkedServiceType,
        displayName: getConnectorV2Name(stringResources.SalesforceServiceCloud_DisplayText, __IS_FABRIC_DPE__),
        linkedServiceNamePrefix: adfModelTypeMap.salesforceServiceCloud.linkedServiceType,
        copySinkTypes: [adfModelTypeMap.salesforceServiceCloudV2.copySinkType],
        copySourceTypes: [adfModelTypeMap.salesforceServiceCloudV2.copySourceType],
        dataflowSource: undefined,
        supportDataFlowSource: false
    };
    return result;
};
